import { z } from "zod/v4";
import { athleteEligibilityResponseSchema, athleteHitSchema } from "../../schemas/bis";
import { fetchApi } from "../client/internal";

export interface AthleteSearchParams {
	q?: string;
	limit?: number;
	offset?: number;
	federation?: string;
	gender?: string;
	ageCategory?: string;
	club?: string;
	sort?: string;
}

export const athletes = {
	// Full-text search over the discovery `athletes` Meilisearch index. Filters
	// map to Meilisearch `filter` expressions against the filterable attributes
	// configured by the Go `shared/meili` package.
	search: (q: string, options: AthleteSearchParams | number = {}) => {
		const params: AthleteSearchParams = typeof options === "number" ? { limit: options } : options;
		const query = new URLSearchParams({ q: q ?? "" });
		if (params.limit) query.set("limit", String(params.limit));
		if (params.offset) query.set("offset", String(params.offset));
		if (params.federation) query.set("federation", params.federation);
		if (params.gender) query.set("gender", params.gender);
		if (params.ageCategory) query.set("ageCategory", params.ageCategory);
		if (params.club) query.set("club", params.club);
		if (params.sort) query.set("sort", params.sort);
		const qs = query.toString();
		return fetchApi(`/athletes?${qs}`, z.array(athleteHitSchema));
	},
	// Manual Jahrgang entry — scrapers don't expose birth year. Returns the
	// recomputed eligibility for the current season.
	setBirthYear: (athleteId: string, birthYear: number) =>
		fetchApi(`/athletes/${athleteId}/birthyear`, athleteEligibilityResponseSchema, {
			method: "PUT",
			body: JSON.stringify({ birthYear }),
		}),
};
